import { useEffect } from "react";
import PhoneInput, {
  formatPhoneNumberIntl,
  isPossiblePhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./PhoneInputField.scss";

const PHONE_INPUT_MESSAGE = "Please enter a valid phone number.";

type PhoneInputFieldProps = {
  id: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  reset?: number;
};

export function isCompletePhoneNumber(value: string) {
  return Boolean(value) && isPossiblePhoneNumber(value);
}

export function formatPhoneForSubmit(value: string) {
  const formatted = formatPhoneNumberIntl(value);
  if (!formatted) {
    return value;
  }

  const separator = formatted.indexOf(" ");
  if (separator === -1) {
    return formatted;
  }

  const callingCode = formatted.slice(0, separator);
  const nationalNumber = formatted.slice(separator + 1).replace(/ /g, "-");
  return `${callingCode} ${nationalNumber}`;
}

function PhoneInputField({
  id,
  name,
  value,
  onChange,
  required = true,
  disabled = false,
  reset,
}: PhoneInputFieldProps) {
  useEffect(() => {
    const input = document.getElementById(id);
    if (!(input instanceof HTMLInputElement)) {
      return;
    }

    if (!value) {
      input.setCustomValidity("");
      return;
    }

    input.setCustomValidity(
      isPossiblePhoneNumber(value) ? "" : PHONE_INPUT_MESSAGE,
    );
  }, [id, value]);

  return (
    <PhoneInput
      key={reset}
      id={id}
      name={name}
      className="phone-input"
      defaultCountry="US"
      international
      countryCallingCodeEditable={false}
      countryOptionsOrder={["US", "|", "..."]}
      addInternationalOption={false}
      limitMaxLength
      value={value}
      onChange={(nextValue) => onChange(nextValue || "")}
      autoComplete="tel"
      required={required}
      disabled={disabled}
    />
  );
}

export default PhoneInputField;
